const prefix = 'insuranceLink';

export const FETCH_DATA = `${prefix}/FETCH_DATA`;